// extracted by mini-css-extract-plugin
module.exports = {"quoteMark":"QuoteBlock_quoteMark__IVJWD","quoteBlock":"QuoteBlock_quoteBlock__-dFSW"};